export default {
  methods: {
    setFileBody (file, label) {
      const blob = file.slice(0, file.size, file.type)
      const filename = label || file.name
      const name = filename.replace(/\(|\)|\s/gmi, '')
      const updatedFile = new File([blob], name, {type: file.type})
      const fileData = new FormData()
      fileData.set('fieldname', 'uploadFile')
      fileData.set('label', name || 'bb-file')
      fileData.set('file', updatedFile)
      return fileData
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/setFileBody.js